import { parseSort } from '@api/reviews/reviewsForVendor/parse-sort';
import { Logger } from '@utils/logger/logger';
import Joi from 'joi';

export interface Query {
	size?: number;
	page?: number;
	sort?: string;
	stars?: number[];
	content?: string;
	hasPhotos?: boolean;
}

const querySchema = Joi.object<Query>({
	size: Joi.number().integer().min(1).max(50).default(20),
	sort: Joi.string().lowercase().default('rating:desc'),
	page: Joi.number().integer().min(1).default(1),
	content: Joi.string().min(2).optional(),
	stars: Joi.array()
		.single()
		.default([])
		.items(Joi.number().min(1).max(5))
		.unique((a, b) => a === b),
	hasPhotos: Joi.boolean().strict().optional(),
});

export const buildVariablesForGetReviewsForStorefront = async (
	storefrontId: string,
	query: Query,
) => {
	try {
		const validated = await querySchema.validateAsync(query);
		// After validation with defaults, these fields are guaranteed to be defined
		const { size, sort, page, stars } = validated as Required<
			Pick<Query, 'size' | 'sort' | 'page' | 'stars'>
		>;
		// These fields remain optional
		const { content, hasPhotos } = validated;

		const parsedSort = parseSort(sort);

		return {
			id: storefrontId,
			size,
			page,
			sort: parsedSort.sort,
			sortType: parsedSort.sortType,
			searchText: content,
			stars,
			photos: hasPhotos,
		};
	} catch (e) {
		Logger.error({
			errorToLog: e,
			newRelic: true,
			log_message:
				'Error in buildVariables function for getReviewsForStorefront',
		});
		throw e;
	}
};
